export default class ScrollArrows {
  constructor(node) {
    this.element = node;

    this.scrollableContent = this.element.querySelector(".tabs");

    this.initialize();
  }

  initialize() {
    this.scrollableContent.addEventListener("scroll", () => {
      requestAnimationFrame(() => {
        const scrollable = this.scrollableContent.scrollWidth - this.scrollableContent.clientWidth;

        if (scrollable === 0) {
          this.element.classList.remove("scroll-left");
          this.element.classList.remove("scroll-right");
          return;
        }

        this.element.classList.toggle("scroll-left", this.scrollableContent.scrollLeft > 0);
        this.element.classList.toggle("scroll-right", this.scrollableContent.scrollLeft < scrollable);

        // Fix for chrome since there's a decimal difference between scrollable and scrollLeft
        if (scrollable - parseInt(this.scrollableContent.scrollLeft) == 1) {
          this.element.classList.remove("scroll-right");
        }
      });
    });

    window.addEventListener("resize", () => {
      requestAnimationFrame(() => {
        this.scrollableContent.dispatchEvent(new Event("scroll"));
      });
    });

    this.scrollableContent.dispatchEvent(new Event("scroll")); // Draw initial state
  }
}
